import React from "react";
import { ExpensesWrapper } from "./ExpensesTables.styled";
import { Row, Col, Input, Form } from "components/common";

const AddExpenses = ({setFormData,formData}) => {

  const handleChange = (e) =>{
setFormData({...formData,
[e.target.name]:e.target.value})
  }
  return (
    <ExpensesWrapper>
      <Form>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <label htmlFor="" className="Expense-label">
            Pay Date
          </label>
          <Form.Item required>
          <Input type="date" className="Expense-Input" name="payDate" onChange={handleChange}/>
          </Form.Item>
        </Col>
        <Col span={24}>
          <label htmlFor="" className="Expense-label">
            Type
          </label>
          <Form.Item required>
          <Input type="text" className="Expense-Input" name="type" onChange={handleChange}/>
          </Form.Item>
        </Col>
        <Col span={24}>
          <label htmlFor="" className="Expense-label" >
            User
          </label>
          <Form.Item required>
          <Input type="text" className="Expense-Input" name="user" onChange={handleChange}/>
          </Form.Item>
        </Col>
        <Col span={24}>
          <label htmlFor="" className="Expense-label">
            Description
          </label>
          <Form.Item required>
          <Input type="text" className="Expense-Input" name="description" onChange={handleChange}/>
          </Form.Item>
        </Col>
        <Col span={24}>
          <label htmlFor="" className="Expense-label">
            Amount
          </label>
          <Form.Item required>
          <Input type="text" className="Expense-Input" name="amount" onChange={handleChange}/>
          </Form.Item>
        </Col>
        <Col span={24}>
          <label htmlFor="" className="Expense-label" >
            Paid Out
          </label>
          <Form.Item required>
          <Input type="text" className="Expense-Input" name="paidOut" onChange={handleChange}/>
          </Form.Item>
        </Col>
        <Col span={24}>
          <label htmlFor="" className="Expense-label" >
            Project
          </label>
          <Form.Item required>
          <Input type="text" className="Expense-Input" name='projectId' onChange={handleChange}/>
          </Form.Item>
        </Col>
      </Row>
      </Form>
    </ExpensesWrapper>
  );
};
export default AddExpenses;
